<template>
  <a class="engagement-navbar">
    <c-button
      v-if="showEngagementButton"
      size="lg"
      data-cy="engagement-button"
      class="engagement-button"
      @click="$emit('engagement-button-click')"
    >
      <div class="content">
        <k-icon
          size="20"
          icon="star-favorite"
        />
        <span class="span -rewards">Recompensas</span>
      </div>

    </c-button>
    <c-button
      v-else
      data-cy="return-button"
      size="lg"
      class="engagement-button"
      @click="$router.push({ name: 'Home' })"
    >
      <div class="content">
        <k-icon
          size="22"
          icon="left"
        />
        <span class="span">Seu Clube</span>
      </div>
    </c-button>
  </a>
</template>

<script>
import { KIcon } from '@/components/KaledoComponents'
export default {
  components: {
    KIcon
  },
  props: {
    showEngagementButton: Boolean
  }
}
</script>

<style lang="scss" scoped>
.engagement-navbar {
  margin-right: 10px;
  .engagement-button {
    width: 155px;
    display: flex;
    .content {
      display: flex;
      & > .span {
        padding: 6px 0px 5px 0px;

        &.-rewards {
          margin-left: 4px;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Layout/Navbar/EngagementNavbar.vue